// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2IxgK","title":"ClientReferral_title__WKyKu","itemText":"ClientReferral_itemText__1WrJ2"};